// commonMixin.js
import { passHelpers } from '../../../helpers';

export default {
	props: {
		currentSection: { type: String, default: '' },
		extraData: { type: Object, default: () => ({}) },
		partner: { type: Object, default: null },
		pass: { type: Object, default: () => ({}) },
		returnUrl: { type: String, default: '' },
		template: { type: Object, default: () => ({}) },
	},
	data() {
		return {
			localPass: {
				...cloneDeep(this.pass),
				...{
					highlights: this.pass.highlights || passHelpers.getPassHighlights(),
					redemption_policy: passHelpers.getRedemptionPolicyObject(this.pass),
					media: this.pass.media || [],
					max_product_redemptions: this.pass.max_product_redemptions,
				}
			},
			rules: passHelpers.getValidationRules(this.$data),
			isSaving: false,
			sections: this.extraData.sections,
		};
	},
	computed: {
		saveText() {
			const isLastSection = passHelpers.isLastSection(this.currentSection, this.sections);
			return isLastSection ? "Save & Exit" : "Save";
		},
	},
	methods: {
		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return passHelpers.getReturnUrl(this.returnUrl, this.partner);
		},

		saveDestination() {
			if(!passHelpers.isLastSection(this.currentSection, this.sections)) {
				this.saveChangesAndNextPage();
			}
			else {
				this.saveChanges();
			}
		},
		saveChangesAndNextPage() {
			this.isSaving = true;
			const nextSection = passHelpers.getNextSection(this.currentSection, this.sections);
			const nextUrl = `/partner-portal/${this.partner.id}/passes/${this.localPass.id}/${nextSection}`;
			passHelpers.saveChanges(this.isSaving, this.partner, this.localPass, nextUrl);
		},
		saveChanges() {
			passHelpers.saveChanges(this.isSaving, this.partner, this.localPass, this.getReturnUrl());
		}
	}
};
